if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartDrawer = document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      this.submitButtonText = this.querySelector('[type="submit"] > span');
      this.cartType = window.theme.settings.cart_type;
      this.formBundles = document.querySelectorAll('.form-bundles');
    }

    onSubmitHandler(event) {
      event.preventDefault();
      if (this.submitButton.classList.contains('is-loading')) return;

      this.handleErrorMessage();

      if (this.cartType == 'drawer') {
        this.cartDrawer.setActiveElement(document.activeElement);
      }

      this.handleSubmitButton();

      if (this.formBundles.length > 0) {
        const fetchedBundlesData = this.addBundlesToCart();
        this.handleFetchedBundlesData(fetchedBundlesData);
      } else {
        const fetchedData = this.addItemToCart();
        this.handleFetchedData(fetchedData);
      }
    }

    addBundlesToCart() {
      let formBundlesData = [];
      const firstForm = this.formBundles[0];
      const timeStamp = Date.now().toString();
      const timeStampInput = this.formBundles[0].querySelector('.form-bundles__props-stamp');
      timeStampInput.value = timeStamp;

      [...this.formBundles].forEach((form) => {
        if (form !== firstForm) {
          const propsInputProduct = form.querySelector('.form-bundles__props-product');
          const propsInputCount = form.querySelector('.form-bundles__props-count');
          const propsData = {
            '_bundle_product': propsInputProduct.value,
            '_bundle_count': propsInputCount.value,
            '_bundle_stamp': timeStamp
          }

          const formBundleData = {
            'id': form.querySelector('[name=id]').value,
            'quantity': form.querySelector('[name=quantity]').value,
            'properties': propsData
          };

          formBundlesData.push(formBundleData);
        }
      });

      return new Promise((resolve, reject) => {
        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
           'items': formBundlesData
          })
        })
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            this.handleSubmitButton(true, response.description);
            return;
          }

          if (response) {
            resolve(response);
            return;
          }

          this.handleSubmitButton(true);

          reject(response);
        })
        .catch((e) => {
          window.console.error(error);
        });
      });
    }

    addItemToCart() {
      return new Promise((resolve, reject) => {
        this.initBundledSectionRendering(this.form);
      });
    }

    handleFetchedData(promise) {
      promise.then((values) => {
        if (values.length === 0) return;

        const fetchedData = values[0];

        if (fetchedData.status) {
          this.handleErrorMessage(fetchedData.description);
          this.handleSubmitButton(true, fetchedData.description);
          return;
        }

        if (this.cartType == 'drawer') {
          this.cartDrawer.handleAddedItem(fetchedData);
        }

        this.handleSubmitButton(true);
      })
      .catch((error) => {
        window.console.error(error);
      });
    }

    handleFetchedBundlesData(promise) {
      promise.then((values) => {
        if (values.length === 0) return;
        return values[0];
      })
      .then((data) => {
        this.initBundledSectionRendering(this.formBundles[0]);
      })
      .catch((error) => {
        window.console.error(error);
      });
    }

    initBundledSectionRendering(form) {
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(form);

      if (this.cartType == 'drawer') {
        formData.append('sections', this.cartDrawer.getSectionsToRender().map((section) => section.id));
      }

      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${window.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            this.handleSubmitButton(true, response.description);
            return;
          }

          if (this.cartType == 'drawer') {
            this.cartDrawer.handleAddedItem(response);
          }

          this.handleSubmitButton(true);

          if (window.BOLD && BOLD.common && BOLD.common.eventEmitter &&
                  typeof BOLD.common.eventEmitter.emit === 'function'){
                BOLD.common.eventEmitter.emit('BOLD_COMMON_cart_loaded');
 }


        })
        .catch((e) => {
          window.console.error(error);
        });
    }

    handleSubmitButton(done = false, errorMessage = false) {
      const addToCartHTML = `${window.theme.strings.product.addToCart}`;
      const addToCartBundlesHTML = `${window.theme.strings.product.addToCartBundles}`;
      const addToCartCourseHTML = `${window.theme.strings.product.addToCartCourse}`;
      const addedToCartHTML = `${window.theme.strings.product.iconAdded} ${window.theme.strings.product.addedToCart}`;
      const isProductCourse = document.querySelector('.template--course') !== null;

      if (done) {
        this.submitButton.classList.remove('is-loading');
        this.submitButton.removeAttribute('aria-disabled');

        if (errorMessage) {
          return;
        }

        this.submitButtonText.innerHTML = addedToCartHTML;

        setTimeout(() => {
          if (this.formBundles.length > 0) {
            this.submitButtonText.innerHTML = addToCartBundlesHTML;
          } else if (isProductCourse) {
            this.submitButtonText.innerHTML = addToCartCourseHTML;
          } else {
            this.submitButtonText.innerHTML = addToCartHTML;
          }
          
        }, 3000);
        return;
      }

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('is-loading');
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('[data-form-error-message-wrapper]');

      if (!this.errorMessageWrapper) {
        return;
      }

      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('[data-form-error-message]');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (!this.errorMessage) {
        return;
      }

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
